export const animIU = 'wow animate__animated animate__fadeInUp'
export const animI = 'wow animate__animated animate__fadeIn'